module.exports = __webpack_public_path__ + "img/user_1.bd8d5cea.png";